import { Component } from '@angular/core';

@Component({
  selector: 'app-config-indicateur',
  templateUrl: './config-indicateur.component.html',
  styleUrls: ['./config-indicateur.component.scss'],
  standalone: false
})
export class ConfigIndicateurComponent {
  tab = 1;

  changerTab(numTab: number) {
    this.tab = numTab;
  }
}
